// Demo version of the header filter menu with hardcoded Mag 7 watchlist
// Used for demo mode when user is not authenticated

import { useMemo } from "react";
import { useHeaderFilterMenu } from "@/shared/hooks/useHeaderFilterMenu";
import { DEMO_WATCHLIST_TICKERS } from "@/shared/api/demo-firehose";

interface DemoHeaderFilterMenuOptions {
  pushAction?: (action: React.ReactElement) => void;
  persistKey?: string;
}

/**
 * Hook that creates a simplified filter menu for demo mode.
 * Only offers the Magnificent 7 watchlist filter (hardcoded).
 */
export const useDemoHeaderFilterMenu = (options: DemoHeaderFilterMenuOptions) => {
  const mag7Label = `Magnificent 7 (${DEMO_WATCHLIST_TICKERS.join(", ")})`;

  // Filter config with just the Mag 7 watchlist option
  const filterConfig = useMemo(
    () => [
      {
        id: "demo-watchlist-filter",
        label: "Filter by Watchlist",
        filterOptions: [
          {
            id: "mag7",
            label: mag7Label,
          },
        ],
        collapsible: true,
        showCount: true,
        defaultCollapsed: false,
      },
      {
        id: "demo-watchlist-highlight",
        label: "Highlight by Watchlist",
        filterOptions: [
          {
            id: "mag7",
            label: "Magnificent 7",
          },
        ],
        collapsible: true,
        showCount: true,
        defaultCollapsed: true,
      },
    ],
    [mag7Label]
  );

  const [filterSelections, setFilterSelections] = useHeaderFilterMenu(
    filterConfig,
    options.pushAction,
    options.persistKey
  );

  return [filterSelections, setFilterSelections] as const;
};
